import { FC, useEffect, useState } from 'react'
import { IoMdArrowBack } from 'react-icons/io'
import { GoPerson } from 'react-icons/go'
import { PiHouse } from 'react-icons/pi'
import { FiBattery } from 'react-icons/fi'
import { Form, Formik, FormikProps } from 'formik'
import CustomText from '../../CustomText'
import HeadingView from '../HeadingView/HeadingView'
import BackButton from '../BackButton/BackButton'
import { useAuthContext } from '../../../context/AuthProvider'
import { Button, Flex } from '@chakra-ui/react'
import TextInput from '../../FormElements/TextInput'
import ConnectedPhoneNumberInput from '../../FormElements/ConnectedPhoneNumberInput'
import { PersonalInfoFormValidation } from '../../../formValidation'
import PropertyCard from '../PropertyCard/PropertyCard'
import { UserProperty } from '../../../generated/graphql'

type StepOneProps = {
  stepCount: number
  totalStep: number
  title: string
  description: string
  activeProperty?: UserProperty
  handleBack: () => void
  handleNext: () => void
  handleSetActiveProperty: (e: UserProperty) => void
}

type InitialValues = {
  firstName: string
  lastName: string
  initials: string
  email: string
  contactNumber: string
  alternateNumber: string
  // idNumber: string
}

export const StepOne: FC<StepOneProps> = ({
  stepCount,
  totalStep,
  title,
  description,
  handleBack,
  activeProperty,
  handleNext,
  handleSetActiveProperty
}: StepOneProps) => {
  const { user } = useAuthContext()
  const [initialValues, setInitialValues] = useState<InitialValues>(() => ({
    firstName: user?.info?.firstName || '',
    lastName: user?.info?.lastName || '',
    initials:
      user?.info?.initials ||
      `${user?.info?.firstName?.slice(0, 1)}${user?.info?.lastName?.slice(0, 1)}`,
    email: user?.info?.email || '',
    contactNumber: user?.info?.contactNumber || '',
    alternateNumber: user?.info?.alternateNumber || ''
  }))

  const [userProperty, setUserProperty] = useState<UserProperty | undefined>()

  useEffect(() => {
    if (activeProperty) {
      setUserProperty(activeProperty)
    }
  }, [activeProperty])

  return (
    <div className={`w-full h-auto flex flex-col gap-y-4`}>
      <HeadingView
        stepCount={stepCount}
        totalStep={totalStep}
        title={title}
        description={description}
      />

      <div className="w-full h-auto p-12 bg-white rounded-[32px] shadow-sm border-solid border-[1.5px] border-[#e4e4e4]">
        <Formik
          validationSchema={PersonalInfoFormValidation}
          initialValues={initialValues}
          enableReinitialize
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={async (
            { firstName, lastName, initials, contactNumber, alternateNumber },
            { setSubmitting, setStatus }
          ) => {
            try {
              console.log(`firstName: `, firstName)
              console.log(`lastName: `, lastName)
              console.log(`initials: `, initials)
              console.log(`contactNumber: `, contactNumber)
              setStatus(null)
              setSubmitting(true)

              setSubmitting(false)
            } catch (error: any) {
              setStatus(error.message)
            }
          }}
        >
          {({ isSubmitting }: FormikProps<InitialValues>) => {
            return (
              <Form style={{ width: '100%' }}>
                <Flex w="full" direction={'column'} gap="25px" mb="25px">
                  <div className={`w-full h-auto flex flex-row gap-x-2 items-center`}>
                    <div className="w-[24px] h-[24px] bg-[#ffbe00] flex flex-row items-center justify-center rounded-full">
                      <GoPerson className="w-[16px] h-[16px]" color="#000000" />
                    </div>

                    <CustomText
                      textLabel={`Account holder`}
                      fontWeight={`font-semibold`}
                      fontSize="text-[18px]"
                      fontColor={`text-black`}
                      customClass="text-center"
                    />
                  </div>
                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-full h-auto flex flex-col">
                        <CustomText
                          textLabel={`FULL NAME`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={`${user?.info?.firstName} ${user?.info?.lastName}` || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`EMAIL`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={user?.info?.email || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>

                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-full h-auto flex flex-col">
                        <CustomText
                          textLabel={`MOBILE`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={`${user?.info?.contactNumber}` || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`ACCOUNT NUMBER`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={user?.info?.customerNumber || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>

                  <div className={`w-full h-auto flex flex-row gap-x-2 items-center`}>
                    <div className="w-[24px] h-[24px] bg-[#ffbe00] flex flex-row items-center justify-center rounded-full">
                      <PiHouse className="w-[16px] h-[16px]" color="#000000" />
                    </div>

                    <CustomText
                      textLabel={`Property`}
                      fontWeight={`font-semibold`}
                      fontSize="text-[18px]"
                      fontColor={`text-black`}
                      customClass="text-center"
                    />
                  </div>
                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={` h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`ADDRESS`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={userProperty?.fullAddress || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                    <div
                      className={`grow h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`ORDER NUMBER`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={userProperty?.orderNumber || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>

                  <div className={`w-full h-auto flex flex-row gap-x-2 items-center pt-4`}>
                    <div className="w-[24px] h-[24px] bg-[#ffbe00] flex flex-row items-center justify-center rounded-full">
                      <FiBattery className="w-[16px] h-[16px]" color="#000000" />
                    </div>

                    <CustomText
                      textLabel={`Solar system`}
                      fontWeight={`font-semibold`}
                      fontSize="text-[18px]"
                      fontColor={`text-black`}
                      customClass="text-center"
                    />
                  </div>

                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`PACKAGE`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={userProperty?.subscription?.productName || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`PANELS`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={
                            `${userProperty?.subscription?.panelCount} x ${userProperty?.subscription?.panelSpec}` ||
                            ''
                          }
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>
                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`INVERTER`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={userProperty?.subscription?.inverterSpec || ''}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                    <div
                      className={`w-full h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`BATTERY`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={
                            `${userProperty?.subscription?.batteryCount} X ${userProperty?.subscription?.batterySpec}` ||
                            ''
                          }
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>
                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                  >
                    <div
                      className={`w-auto h-full px-[16px] py-[16px] bg-[#FCFBF6] flex flex-row items-center gap-x-[16px] rounded-[28px] border-solid border-[1.5px] border-[#d0d0d0]`}
                    >
                      <div className="w-auto h-auto flex flex-col">
                        <CustomText
                          textLabel={`INSTALLED`}
                          fontWeight={`font-regular`}
                          fontSize="text-[12px]"
                          fontColor={`text-black`}
                        />

                        <CustomText
                          textLabel={userProperty?.installationDate || 'No installation date'}
                          fontWeight={`font-semibold`}
                          fontSize="text-[16px]"
                          fontColor={`text-black`}
                        />
                      </div>
                    </div>
                  </Flex>

                  <Flex
                    direction={['column', 'column', 'row', 'row']}
                    justifyContent={'space-between'}
                    gap={['25px', '25px', '25px', '10%']}
                    alignItems={'center'}
                  >
                    {/* <ConnectedIDNumberInput
                      name="idNumber"
                      label="ID/Passport"
                      placeholder=""
                      bg="transparent"
                      mb={[4, 8]}
                    /> */}
                    <div className="w-fit h-fit flex flex-row justify-between">
                      <BackButton label="Back" handleClick={handleBack} isBack={false}>
                        <IoMdArrowBack className="w-[20px] h-[20px]" color="#000000" />
                      </BackButton>
                    </div>

                    <Flex w="100%" h="100%" alignItems={'center'} justifyContent="flex-end">
                      <Button
                        variant={'dark'}
                        isLoading={isSubmitting}
                        onClick={handleNext}
                        type="submit"
                        mt="15px"
                      >
                        Continue
                      </Button>
                    </Flex>
                  </Flex>
                </Flex>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default StepOne
